import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Table, TableBody, TableHead, TableCell, TableRow, Grid, CircularProgress, Card, CardContent } from '@material-ui/core';
import { BajarContratoLogic } from '../../../view-model/Contrato/Contrato.logic';
import logoUDD from '../../../../assets/svg/logo-udd-blanco.svg';
//import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
type Props = {
}
export const DescargaContrato: React.FC<Props> = () => {
    const history = useHistory();
    const location = useLocation();
    const [cargandoValores, setCargandoValores] = useState(true)
    const [error, setError] = useState(false)

    const selVerContrato = (error: Boolean, err: string, result: any) => {
        setCargandoValores(false)
        if (error === false) {
            setError(false)
        } else {
            setError(true)
        }
    }
    useEffect(() => {
        if (!cargandoValores) {
            /* console.log("Cerrar")
            window.self.close(); */
        }
    }, [cargandoValores])
    useEffect(() => {
        let url = window.location.href;
        if (url.indexOf('?') !== -1) {
            var alumno = queryString.parse(window.location.search);
            console.log(alumno)
            BajarContratoLogic(selVerContrato, parseInt(alumno.rut!.toString()), alumno.codCarrera!.toString())
        } else {
            history.push({
                pathname: "/Inicio"
            });
        }
    }, [])
    const cerrarVentana = () => {
        /* window.self.close(); */
    }

    return (
        <>
            <header style={{ position: 'fixed', display: 'grid', zIndex: 99 }} className="site-header">
                <title>Matrícula Web Universidad Del Desarrollo</title>
                <meta name='description' content='Proceso de Matrícula Web Universidad Del Desarrollo.'></meta>
                <div className="site-header__container2">
                    <div style={{ display: 'flex' }}>
                        <div>
                            <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                        </div>
                    </div>
                </div>
            </header>

            <br></br>
            <br></br>
            <br></br>
            {cargandoValores ?
                <div className="site-main__container">
                    <div style={{ textAlign: 'center', marginTop: 100 }}>

                        <CircularProgress disableShrink />
                        <br />
                        <a><span>Cargando contrato.</span></a>

                    </div>
                </div>
                :
                error ?
                    <div className="site-main__container">
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                            <br />
                            <a><span>Ocurrió un problema al obtener su contrato, favor comunicarse con la universidad.</span></a>

                        </div>
                    </div>
                    :
                    ""
            }
        </>
    )
}
export default DescargaContrato;
